import React, {useState, useEffect, useContext} from "react";
import styled from "styled-components";
import {UserContext} from "../contexts/user";
import firebase from "firebase/app";
import {capitalize, sum} from "lodash";
import html2canvas from "html2canvas";
import { useNavigate, useParams } from 'react-router-dom';


const success = "#5cb85c";
const warning = "#f0ad4e";
const dangerRed = "#ff5f5f";
const neutral = "#003b00";

const color = props => {
  if (props.danger) {
    return dangerRed;
  } else if (props.success) {
    return success;
  } else if (props.warning) {
    return warning;
  }
  return neutral;
};

const Button = styled.button`
  display: flex;
  gap: 5px;
  font-family: "IBM Plex Mono";
  font-size: ${props => (props.large ? "1.25rem" : "1rem")};
  border: 2px solid ${props => color(props)};
  font-weight: 700;
  background-color: ${props => (props.primary ? props.theme.newGreen : "transparent")};
  color: ${props => color(props)};
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  padding: 0.5em 0.75em;

  &:hover {
    background-color: ${props => props.theme.newGreen};
    color: ${props => (props.type === "danger" ? "white" : "initial")};
  }

  &:disabled {
    cursor: not-allowed !important;
    pointer-events: none;
    background-color: #fff;
    opacity: 0.5;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
  }
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  input:checked + .slider {
    background-color: #007c41;
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #007c41;
  }
  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }
`;

const Layout = styled.div`
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset;
  border-radius: 10px;
  padding: 30px;
  margin: 50px auto;
  // width: 85%;
  max-width: 1200px;
  width: 100%;
  // margin: 0px auto;
  .dispute-wrapper {
    position: absolute;
  }
  .header-details {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: center;
    @media screen and (max-width: 700px) {
      flex-direction: column;
      align-items: start;
      .header-divider {
        display: none;
      }
    }

    .header-divider {
      color: #b5b5b5;
    }
    .action-btn {
      cursor: pointer;
      &.dispute-btn {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      }
      border: none;
      border-radius: 5px;
      font-weight: 600;
      font-size: 16px;
      padding: 10px 40px;
      background: #ededed;
      color: #000000;
      max-width: 100%;
    }
  }
  .order-details {
    margin: 30px 0;
    color: #d4d4d4ff;
    h3 {
      margin: 5px 0;
    }
    .subtotal-detail {
      display: flex;
      justify-content: space-between;
    }
    &.services-ordered {
      margin: 10px 0;
      cursor: pointer;
      &:hover {
        color: #37d70bff;
      }
    }

    .requirement-container {
      margin: 10px 0;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
  .section-divider {
    background-color: #dfdfdf;
    height: 1px;
    border: 0;
    margin-bottom: 25px;
  }
`;

const RequirementButton = styled(Button)`
  border: 1px solid;
  background: #008427;
  color: #ffffff;
  border-radius: 10px;
  cursor: pointer;
  &.cancel {
    background: #ff67ad;
    padding: 5px 5px;
    font-size: 14px;
    border-radius: 5px;
  }
  &.refund {
    background: rgb(174, 103, 255);
    padding: 5px 5px;
    font-size: 14px;
    border-radius: 5px;
  }
  &.course{
    display: inline-block;
    margin-top: 28px;
    background: linear-gradient(90deg, var(--hn-green), var(--hn-yellow));
    color: var(--hn-black);
    font-weight: 700;
    padding: 16px 48px;
    font-size: 1.15rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    font-family: 'Fira Mono', monospace;
  }
  :hover {
    background: #17b605;
    color: #ffffff;
  }
  :disabled {
    background: #008427;
  }
`;

const SubNavButton = styled(Button)`
  border-radius: 5px;
  border: none;
  background: #efefef;
  color: #303030;
  &.filter-selected {
    text-decoration: underline;
  }
  &.service-admin-btn {
    background: #1b6200;
    color: #ffffff;
  }
`;

const AddOnContainer = styled.div``;

const Service = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  const {user, userDispatch, loadingAuthState = true} = useContext(UserContext);
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cancelServiceWarning, setCancelServiceWarning] = useState(false);
  const [requirementContent, setRequirementContent] = useState([]);
  const [serviceAddons, setServiceAddons] = useState([]);
  const [paidAddOns, setPaidAddOns] = useState([]);

  const [showDispute, setShowDispute] = useState(false);
  const [error, setError] = useState("");
  const [loadingApplyCredit, setLoadingApplyCredit] = useState(false);
  const [showFeatures, setShowFeatures] = useState("");
  const [checkoutData, setCheckoutData] = useState(null);
  const [showPaymentMethodForm, setShowPaymentMethodForm] = useState(false);
  // const {confirmDispatch} = useContext(ConfirmContext);
  const [customerCards, setCustomerCards] = useState([]);



  useEffect(() => {
    (async function () {
      if (loadingAuthState) return;
      const id = orderId;
      if (!id) return;
      const {currentUser} = firebase.auth();
      if (!currentUser) {
        alert(
          "You must be logged first to view this page. If you just purchased a service, please log in with the same email you use to for the payment!",
        );
        return;
      }
      const token = await currentUser.getIdToken();

      const mongoUrl = new URL(
        `https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/orders`,
      );
      // const mongoUrl = new URL(`http://localhost:8087/services/orders`);
      mongoUrl.searchParams.append("orderId", id);

      try {
        const req = await fetch(mongoUrl?.toString(), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          // credentials: "include",
        });
        const response = await req.json();
        if (response.ok === true) {
          setOrderData(response?.orderdata);
          if (response?.serviceAddons && response?.serviceAddons?.length > 0) {
            setServiceAddons(response?.serviceAddons);
          }
          if (response?.paidAddOns && response?.paidAddOns?.length > 0) {
            setPaidAddOns(response?.paidAddOns);
          }
        } else {
          navigate("/my-courses")
        }
      } catch (e) {
        console.log("something went wrong!", e);
        // history.replace({pathname: `/services`});
      }
      setLoading(false);
    })();
  }, [loadingAuthState]);

  const getOrderNumber = () => {
    var txt = orderData?._id;
    if (!txt) return;
    var numb = txt.match(/\d/g);
    numb = numb.join("");
    return numb.slice(0, 8);
  };

  const handleDownloadPng = () => {
    const domElement = document.getElementById("print");
    if (domElement) {
      // console.log(domElement.style.boxShadow);

      domElement.style.boxShadow = "unset !important";
      domElement.style.background = "#161616";

      html2canvas(domElement).then(canvas => {
        // Convert canvas to a PNG data URL
        const pngDataUrl = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = pngDataUrl;
        downloadLink.download = `hackernoon-order-${orderData?._id}.png`;
        downloadLink.textContent = "Download PNG";

        // Append the link and trigger a click
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        domElement.style.boxShadow = "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,rgb(209, 213, 219) 0px 0px 0px 1px inset";
      });
    }
  };

  const handleRequirementContent = str => {
    let arr = [...requirementContent];
    if (arr.includes(str)) {
      arr = arr.filter(item => item !== str);
    } else {
      arr.push(str);
    }

    setRequirementContent([...arr]);
  };

  const handleCancelServiceByAdmin = async (serviceId, orderId) => {
    const token = await firebase.auth().currentUser.getIdToken();
    var mongoUrl = new URL(
      "https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/cancel-service-by-admin",
    );

    // const mongoUrl = new URL(`http://localhost:8086/services/cancel-service-by-admin`);
    mongoUrl.searchParams.append("serviceId", serviceId);
    mongoUrl.searchParams.append("orderId", orderId);

    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const res = await req.json();
      if (res.ok) {
        window.location.reload();
      } else {
        console.log("Not successfull");
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
    // updateRequirement(data);
  };

  const handleCancelServiceByOwner = async (serviceId, orderId, feeAmount) => {
    const token = await firebase.auth().currentUser.getIdToken();
    var mongoUrl = new URL(
      "https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/cancel-service-by-owner",
    );

    // const mongoUrl = new URL(`http://localhost:8086/services/cancel-service-by-owner`);
    mongoUrl.searchParams.append("serviceId", serviceId);
    mongoUrl.searchParams.append("orderId", orderId);
    mongoUrl.searchParams.append("feeAmount", feeAmount);

    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const res = await req.json();
      if (res.ok) {
        window.location.reload();
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
    // updateRequirement(data);
  };

  const handleApplyCredits = async (serviceId, requirementId, optionId, recurrence = null) => {
    // setShowWarning();

    const token = await firebase.auth().currentUser.getIdToken();

    var mongoUrl = new URL(
      "https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/apply-requirement",
    );
    // const mongoUrl = new URL(`http://localhost:8085/services/apply-requirement`);
    mongoUrl.searchParams.append("serviceId", serviceId);
    mongoUrl.searchParams.append("requirementId", requirementId);
    mongoUrl.searchParams.append("orderId", orderData?._id);
    mongoUrl.searchParams.append("optionId", optionId);
    if (recurrence) {
      mongoUrl.searchParams.append("recurrence", recurrence);
    }

    setLoadingApplyCredit(true);
    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        // credentials: "include",
        body: JSON.stringify({message: "credit applied!"}),
      });
      const res = await req.json();
      if (res.ok) {
        window.location.reload();
      } else {
        console.log("Not successfull");
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
    setLoadingApplyCredit(false);
    // updateRequirement(data);
  };


  const handleSetCheckoutData = async (addOnId, serviceId) => {
    if (checkoutData) return setCheckoutData(null);

    const headers = {
      "Content-Type": "application/json",
    };

    const {currentUser} = firebase.auth();
    if (!currentUser) {
      alert("You must be logged first");
      return;
    }

    const token = await currentUser.getIdToken();
    const bearer = `Bearer ${token}`;
    headers["Authorization"] = bearer;

    const url = new URL(
      "https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/addOn-checkout",
    );
    // const url = new URL("http://localhost:8086/services/addOn-checkout");
    url.searchParams.append("addOnId", addOnId);
    url.searchParams.append("serviceId", serviceId);
    url.searchParams.append("orderId", orderId);

    try {
      const req = await fetch(url?.toString(), {
        method: "GET",
        headers,
        // credentials: "include",
      });
      const response = await req.json();
      if (response.ok === true) {
        setCheckoutData(response?.checkoutData);
        if (response?.customerCards && response?.customerCards?.length > 0) {
          setCustomerCards(response?.customerCards);
        }
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
  };


  const getFeeAmount = (option, service) => {
    const taxPercent = 2.9;
    const optionPrice = parseFloat(option?.price["$numberDecimal"]);

    let subTotal = +optionPrice.toFixed(2);

    const addRecurrence = !!service?.paymentRecurrence && !!service?.recurrence && service?.recurrence !== "none";
    let creditsWorth = 650;
    if (addRecurrence) {
      const paymentRecurrence = service?.paymentRecurrence;
      if (service?.recurrence === "monthly") {
        // console.log("hereeeee", service?.recurrence)
        subTotal = +(subTotal / 12 + ((+paymentRecurrence?.monthlyFee || 0) / 100) * +subTotal).toFixed(2);
      } else {
        creditsWorth = creditsWorth * 12;
        subTotal = +(subTotal + ((+paymentRecurrence?.yearlyFee || 0) / 100) * subTotal).toFixed(2);
      }
    } else {
      // console.log("no recurrence, something went wrong");
      return;
    }

    const tax = +((taxPercent / 100) * subTotal).toFixed(2);
    const total = +(subTotal + tax).toFixed(2);
    const fee = +(creditsWorth - total).toFixed(2);
    return fee;
  };

  const handleRefundSubscription = async (refundAmount, orderId, serviceId, paymentIntent) => {
    // console.log("hereeee", refundAmount, orderId, serviceId, paymentIntent);

    var url = new URL("https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/refund-service");
    // const url = new URL(`http://localhost:8086/services/refund-service`);
    url.searchParams.append("refundAmount", refundAmount);
    url.searchParams.append("orderId", orderId);
    url.searchParams.append("serviceId", serviceId);
    url.searchParams.append("paymentIntent", paymentIntent);

    const token = await firebase.auth().currentUser.getIdToken();
    try {
      const req = await fetch(url?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        // credentials: "include",
      });
      const res = await req.json();
      if (res.ok) {
        if (window.location) {
          window.location.reload();
        }
        // setOrderData({...temp, files});
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
  };

  if(loading) { 
    return (
      <div className="loading-component">
        <lottie-player 
          src="/loader_lottie.json" 
          background="transparent" 
          speed="1" 
          style={{width: '300px', height: '300px'}}
          loop 
          autoplay>
        </lottie-player>
      </div>
    )
  }

  const couponDiscount = (orderData?.servicesPaid || []).map(({option, coupon = null}) => {
    if (coupon) {
      const percent = coupon?.percent || 0;
      const price = parseFloat(option?.price["$numberDecimal"]);
      const couponPrice = +((percent / 100) * price).toFixed(2);
      return couponPrice;
    } else {
      return 0;
    }
  });

  const privileged = user?.isAdmin || user?.isEditor;

  // console.log("paidAddOns", paidAddOns)
  return (
    <>
      <Layout id="print">
        <div className="header-details">
          <div>
            <h2 style={{margin: "0px"}}>Details for order #{getOrderNumber()}</h2>
          </div>
          <div className="header-divider">{"|"}</div>
          <div>
            <button className="action-btn" onClick={() => handleDownloadPng()}>
              Save Receipt
            </button>
          </div>
          <div className="header-divider">{"|"}</div>
          <div>
            <button
              className={`action-btn ${showDispute ? "dispute-btn" : ""}`}
              onClick={() => window.open(`https://app.hackernoon.com/services/orders/${orderId}`, "_blank")}
            >
              Support
            </button>
          </div>
        </div>
        <div className="order-details">
          <h3>Order Placed</h3>
          <p>{new Date(orderData?.createdAt)?.toDateString()}</p>
        </div>
        <div className="order-details">
          <h3>Order Status</h3>
          <p>{capitalize(orderData?.stripeReceipt?.status)}</p>
        </div>
        <div className="order-details">
          <h3>HackerNoon.com Order ID</h3>
          <p>{orderData?._id}</p>
        </div>
        <div className="order-details">
          <h3>Order Total</h3>
          <p>
            USD{" "}
            {(orderData?.stripeReceipt?.amount / 100)?.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>
        </div>
        {orderData?.paymentUpdateRequest === true && (
          <div className="order-details">
            <h3 style={{color: "#cd5959"}}>Payment Method Required</h3>
            <p style={{margin: "10px 0px"}}>Your payment method was not saved in our system, please re-enter it:</p>
            <p style={{margin: "10px 0px", fontStyle: "italic"}}>
              If payment is overdue, we will charge it in the next billing cycle, which runs daily.
            </p>
            <Button
              style={{borderRadius: "5px"}}
              disabled={orderData?.recipient !== user?.uid}
              onClick={() => setShowPaymentMethodForm(!showPaymentMethodForm)}
            >
              Update Payment Method
            </Button>
            {/* <Button>Update Payment & Pay Now</Button> */}
          </div>
        )}

        {privileged && (
          <div className="order-details">
            <h3>Service Recipient {"(Admin Only)"}</h3>
            <p style={{margin: "5px 0"}}>
              userId:{" "}
              <a
                style={{textDecoration: "none", color: "#ffffff"}}
                href={`https://app.hackernoon.com/admin/edit-user/${orderData?.recipient}`}
                target="_blank"
              >
                {orderData?.recipient}
              </a>
            </p>
            {orderData?.recipientProfile && (
              <p style={{margin: "5px 0"}}>
                Name:{" "}
                <a
                style={{textDecoration: "none", color: "#ffffff"}}
                  href={`https://hackernoon.com/u/${orderData?.recipientProfile?.handle}`}
                  target="_blank"
                >
                  {orderData?.recipientProfile?.displayName || orderData?.recipientProfile?.handle}
                </a>
              </p>
            )}
            {orderData?.recipientUser && (
              <p style={{margin: "5px 0"}}>
                Email:{" "}
                <a style={{textDecoration: "none", color: "#ffffff"}}
                  href={`mailto:${orderData?.recipientUser?.email}`}>
                  {orderData?.recipientUser?.email}
                </a>
              </p>
            )}
          </div>
        )}

        <hr className="section-divider" />

        <h2 style={{margin: "0px"}}>Ordered on {new Date(orderData?.createdAt)?.toDateString()}</h2>
        <div className="order-details">
          <h3>{orderData?.servicesPaid?.length > 1 ? "Services" : "Service"} Ordered:</h3>
        </div>
        <div>
          {orderData?.servicesPaid &&
            orderData?.servicesPaid?.map(
              (
                {
                  service,
                  coupon,
                  addOns,
                  option,
                  active: serviceActive,
                  canceled = false,
                  refunded = false,
                  cancelationFeePaymentIntent = null,
                  paymentHistory = [],
                },
                i,
              ) => {
                return (
                  <React.Fragment key={option?._id}>
                    <div
                      className="order-details services-ordered"
                      onMouseEnter={() => setShowFeatures(option._id)}
                      onMouseLeave={() => setShowFeatures("")}
                    >
                      <p>
                        ({++i}) {service?.title} {option?.title && `- ${option?.title}`}{" "}
                        {option?.subTitle && `(${option?.subTitle})`}
                        {service?.recurrence && ` - ${service?.recurrence} plan`}
                      </p>
                      {option?.description && <small>{option?.description}</small>}
                    </div>
                    {service?._id === "68b959f9eeb27a895ba20f48" && (
                      <div className="requirement-container">
                        <RequirementButton
                          className="course"
                          onClick={() => navigate("/my-courses")}
                        >                          
                          View My Courses
                        </RequirementButton>
                      </div>
                    )}
                
                  </React.Fragment>
                );
              },
            )}
        </div>
        {paidAddOns?.length > 0 && (
          <>
            <div className="order-details">
              <h3>Order Add-Ons</h3>
            </div>
            <div>
              {paidAddOns.map((addOn, i) => {
                return (
                  <React.Fragment key={i}>
                    <div className="order-details services-ordered">
                      <p>
                        {addOn?.title} |{" "}
                        {(addOn?.stripeReceipt?.amount / 100)?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}{" "}
                        | {capitalize(addOn?.stripeReceipt?.status)} | {new Date(addOn?.purchaseDate).toDateString()}
                      </p>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </>
        )}
        <br />
        <hr className="section-divider" />
        <h2 style={{margin: "0px"}}>Payment Information</h2>
        <div className="order-details">
          <h3>Payment Method</h3>
          <p>
            {capitalize(orderData?.stripePaymentMethod?.card?.brand)} ending in{" "}
            {orderData?.stripePaymentMethod?.card?.last4}
          </p>
        </div>
        <div className="order-details">
          <h3>Order Summary</h3>

          <div className="subtotal-detail">
            <div>Subtotal</div>
            <div>
              {(orderData?.stripeReceipt?.amount / 100 + sum(couponDiscount))?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </div>
          </div>
          <div className="subtotal-detail">
            <div>Discount</div>
            <div>${sum(couponDiscount)}</div>
          </div>
          <div className="subtotal-detail">
            <div>Total</div>
            <div>
              {(orderData?.stripeReceipt?.amount / 100)?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </div>
          </div>
        </div>

        {orderData?.servicesPaid.filter(item => item?.nextPayment)?.length > 0 && (
          <>
            <div className="order-details">
              <h3>Next Payment</h3>
            </div>
            <div>
              {orderData?.servicesPaid
                .filter(item => item?.nextPayment)
                .map(({service, nextPayment, option, status = true}) => {
                  return (
                    <React.Fragment key={option?.id + nextPayment}>
                      <div className="order-details services-ordered">
                        <p>
                          {service?.title} {option?.title && `- ${option?.title} `}
                          scheduled for {new Date(nextPayment).toDateString()}
                        </p>
                      </div>
                    </React.Fragment>
                  );
                })}
            </div>
          </>
        )}
      </Layout>
    </>
  );
};

export default Service;
